import axios from "axios";
import APP_CONFIG from "../../app/configuration/AppConfig";

const baseUrl = `${APP_CONFIG.serviceUrls.apiHostUrl}/tcmFirmwareUpdate`;

export interface ITcmFirmwareUpdateSiteSettingsDto {
  targetTcmVersion?: string;
  firmwareSwitchPolicy?: FirmwareSwitchPolicyDto;
}

export enum FirmwareSwitchPolicyDto {
  Immediate = "Immediate",
  OffHours = "OffHours",
}

export enum TrackerAutoFirmwareUpdateStatus {
  Undefined = 0,
  NotApplicable = 1,
  VersionAligned = 2,
  UpdateInProgress = 3,
  PendingActivation = 4,
  InBackoffStateDueToRecurringFailures = 5,
}

export enum TcmFirmwareAutoUpdateMode {
  Undefined = 0,
  Auto = 1,
  Manual = 2,
}

export enum TcmFirmwareUpdateSyncStateDto {
  McsInManualMode = "McsInManualMode",
  MissingTargetTcmVersion = "MissingTargetTcmVersion",
  MissingFirmwareSwitchPolicy = "MissingFirmwareSwitchPolicy",
  McsVersionNotCoherent = "McsVersionNotCoherent",
  TwinAndSettingsMatch = "TwinAndSettingsMatch",
  NeedsTwinUpdate = "NeedsTwinUpdate",
  Exception = "Exception",
}

export interface SiteTcmFirmwareUpdateSyncStateDto {
  validationResults: TcmFirmwareUpdateSyncStateDto[];
  updateTime: number;
}

export enum FirmwareUpgradeMode {
  Manual = "Manual",
  Automatic = "Automatic",
}

export enum SetFirmwareUpgradeModeResultCode {
  Unknown = "Unknown",
  Success = "Success",
  NotAllowed = "NotAllowed",
  UnexpectedError = "UnexpectedError",
}

export enum FirmwareUpgradeCommandResultCode {
  Unknown = "Unknown",
  Success = "Success",
  NotAllowed = "NotAllowed",
  McsInManualMode = "McsInManualMode",
  McsInOngoingUpgrade = "McsInOngoingUpgrade",
  UnexpectedError = "UnexpectedError",
}

export async function getFirmwareVersions(signal?: AbortSignal) {
  const url = `${baseUrl}/firmwareVersions`;
  const response = await axios.get<string[]>(url, { signal });
  return response.data;
}

export async function getSiteTcmFirmwareUpdateSyncState(siteId: string) {
  const url = `${baseUrl}/${siteId}/tcmFirmwareUpdateSyncState`;
  const response = await axios.get<SiteTcmFirmwareUpdateSyncStateDto>(url);
  return response.data;
}

export async function getTcmFirmwareUpdateSettings(siteId: string) {
  const url = `${baseUrl}/${siteId}/settings`;
  const response = await axios.get<ITcmFirmwareUpdateSiteSettingsDto>(url);
  return response.data;
}

export async function setTcmFirmwareUpdateSettings(
  siteId: string,
  value: ITcmFirmwareUpdateSiteSettingsDto
) {
  const url = `${baseUrl}/${siteId}/settings`;
  const response = await axios.post<ITcmFirmwareUpdateSiteSettingsDto>(url, value);
  return response.data;
}

export async function setFirmwareUpgradeMode(siteId: string, mode: FirmwareUpgradeMode) {
  const url = `${baseUrl}/${siteId}/mode`;
  const response = await axios.post<SetFirmwareUpgradeModeResultCode>(url, { mode });
  return response.data;
}

export async function startNewFirmwareUpgrade(siteId: string) {
  const url = `${baseUrl}/${siteId}/startNewUpgrade`;
  const response = await axios.post<FirmwareUpgradeCommandResultCode>(url);
  return response.data;
}

export async function completePendingFirmwareUpgradeTrackers(siteId: string) {
  const url = `${baseUrl}/${siteId}/completePendingTrackers`;
  const response = await axios.post<FirmwareUpgradeCommandResultCode>(url);
  return response.data;
}
